
import { defineComponent } from "vue";

export default defineComponent({
  name: "CheckBox",
  data() {
    const result = this.modelValue;
    return { result };
  },
  props: {
    modelValue: Boolean,
    field_name: String,
    valid: Boolean,
    invalid: Boolean,
    advise: String,
    format: String,
  },
  emits: ["update:modelValue"],
  watch: {
    result(n) {
      this.$emit("update:modelValue", n);
    },
    modelValue(n) {
      this.result = n;
    },
  },
});
